import { ActualGraphQLError } from '@atlaskit/teams-client';
import { type TeamWithMemberships } from '@atlassian/ptc-common';

import { type TeamSearchGQLTeamFormatV2 } from './types';

const EXCLUDED_GRAPHQL_ERROR_MESSAGES = ['TeamDeleted'];

export function filterExcludedMessages(errors: readonly ActualGraphQLError[]) {
	return errors.filter(
		(error) =>
			EXCLUDED_GRAPHQL_ERROR_MESSAGES.every(
				(excludedMessage) => !error.message.includes(excludedMessage),
			) && error?.extensions?.classification !== 'TEAMS_TEAM_DELETED',
	);
}

export const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
export const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
export const USER_ARI_PREFIX = 'ari:cloud:identity::user/';
export const ORG_ARI_PREFIX = 'ari:cloud:platform::org/';

export const fromV2ToTeamSearchViewFormat = (
	nodes: TeamSearchGQLTeamFormatV2[],
): TeamWithMemberships[] => {
	return nodes.map((node) => {
		return {
			id: trimTeamARI(node.team.id),
			orgId: node.team.organizationId,
			membershipSettings: node.team.membershipSettings,
			description: node.team.description,
			displayName: node.team.displayName,
			state: node.team.state,
			largeAvatarImageUrl: node.team.largeAvatarImageUrl,
			smallAvatarImageUrl: node.team.smallAvatarImageUrl,
			largeHeaderImageUrl: node.team.largeHeaderImageUrl,
			smallHeaderImageUrl: node.team.smallHeaderImageUrl,
			members: node.team.members?.nodes
				?.filter((memberNode) => memberNode.member?.id)
				?.map((memberNode) => ({
					id: trimUserARI(memberNode.member?.id),
					status: memberNode.member?.accountStatus,
					fullName: memberNode.member?.name || '',
					avatarUrl: memberNode.member?.picture,
				})),
			memberCount: node.memberCount,
			includesYou: node.includesYou,
			isVerified: node.team.isVerified,
		};
	});
};

export const trimTeamARI = (teamId = '') => {
	return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
};

export const trimUserARI = (userId = '') => {
	return userId.replace(USER_ARI_PREFIX, '');
};
export const trimOrgARI = (orgId?: string) => {
	return orgId?.replace(ORG_ARI_PREFIX, '');
};
